import axios from 'axios';

// Create a base axios instance
const apiService = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3002',
  headers: {
    'Content-Type': 'application/json'
  }
});

// Create a variable to store the clerk instance
let clerkInstance = null;

// Function to set the clerk instance from a component
export const setClerkInstance = (clerk) => {
  clerkInstance = clerk;
};

// Add response interceptor to handle authentication errors
apiService.interceptors.response.use(
  response => response,
  error => {
    // Check if the error is due to expired authentication
    if (error.response && 
      error.response.status === 401 && 
      error.response.data) {

      if (error.response.data.authExpired) {
        console.log('Authentication expired, redirecting to sign out...');
        
        // Sign out using Clerk if available
        if (clerkInstance) {
          clerkInstance.signOut().then(() => {
            // Redirect to home or login page after successful sign out
            window.location.href = '/';
          });
        } else {
          // Fallback if clerk instance isn't available
          window.location.href = '/';
        }
      }
    }
    return Promise.reject(error);
  }
);

// Add request interceptor to add auth token
export const addAuthInterceptor = (getToken) => {
  apiService.interceptors.request.use(
    async config => {
      if (getToken) {
        const token = await getToken();
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
      return config;
    },
    error => Promise.reject(error)
  );
};

export default apiService;